module.exports = __webpack_public_path__ + "static/media/slow-creative-typo-blk.4198af91.svg";